import { render, staticRenderFns } from "./index.vue?vue&type=template&id=abf341a6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=abf341a6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf341a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abf341a6')) {
      api.createRecord('abf341a6', component.options)
    } else {
      api.reload('abf341a6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=abf341a6&scoped=true", function () {
      api.rerender('abf341a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/ShippingManagement/index.vue"
export default component.exports